export default __webpack_public_path__ + "static/media/logo.1ac4a360.svg";